const newsletter = {
    load() {
      let e = document.getElementById("newsletter-name");
      if(e === undefined || e === null){
          return;
      }

      e.addEventListener('keyup', () => {
          document.getElementById("newsletter-terms-box").classList.remove("d-none");
      });
      e.addEventListener('change', () => {
          document.getElementById("newsletter-terms-box").classList.remove("d-none");
      });

      document.getElementById("newsletter-button").addEventListener('click',() => {
          fetch("/api/newsletter", {
              method: "POST",
              headers: http.headers(),
              body: JSON.stringify({
                  first_name: document.getElementById("newsletter-name").value,
                  email: document.getElementById("newsletter-email").value,
                  terms: document.getElementById("newsletter-terms").checked ? 1 : 0,
              }),
          })
              .then((response) => response.json())
              .then((data) => {
                  if (data.code === 200) {
                      document.getElementById("newsletter-message").classList.remove("alert-danger");
                      document.getElementById("newsletter-message").innerHTML = "Successful registration";
                  } else if (data.errors){
                      document.getElementById("newsletter-message").classList.add("alert-danger");
                      document.getElementById("newsletter-message").innerHTML = "";
                      if(data.errors.email) {
                          document.getElementById("newsletter-message").innerHTML += "<br>"+data.errors["email"][0];
                      }
                      if(data.errors.first_name) {
                          document.getElementById("newsletter-message").innerHTML += "<br>"+data.errors["first_name"][0];
                      }
                      if(data.errors.terms) {
                          document.getElementById("newsletter-message").innerHTML += "<br>"+data.errors["terms"][0];
                      }
                  }
              })
              .catch((error) => {
                  console.log("error", error);
              });
      });
    },
};
window.addEventListener("DOMContentLoaded", () => {
    newsletter.load();
});
if (document.readyState !== "loading") {
    newsletter.load();
}
